import * as React from 'react';
import * as _ from 'lodash';
import { Modal, FormControl, FormGroup, Col, ControlLabel, Alert } from 'react-bootstrap';
import { ICrossMatchRejectionReason } from '@nkr/models/index';

interface IProps {
    show: boolean,
    isPastDeadline: boolean,
    crossMatchRejectionReasonList: ICrossMatchRejectionReason[],
    onSubmitDecline: (blockFutureMatches: boolean, deactivatePair: boolean, lateReason: string, rootCausePrimary: number, rootCauseSecondary: number, rejectionReasonText: string, measuresToTake: string, initials: string) => void,
    onCancel: () => void
}

interface IState {
    blockFutureMatches: boolean,
    deactivatePair: boolean,
    lateReason: string,
    rootCausePrimary: number,
    rootCauseSecondary: number,
    rejectionReasonText: string,
    measuresToTake: string,
    initials: string,
    declineValidation: {
        blockFutureMatchesValid: boolean,
        deactivatePairValid: boolean,
        lateReasonValid: boolean,
        rootCausePrimaryValid: boolean,
        rootCauseSecondaryValid: boolean,
        rejectionReasonTextValid: boolean,
        measuresToTakeValid: boolean,
        initialsValid: boolean
    },
    dirty: boolean
}

const initialState: IState = {
    blockFutureMatches: true,
    deactivatePair: true,
    lateReason: '',
    rootCausePrimary: -1,
    rootCauseSecondary: -1,
    rejectionReasonText: '',
    measuresToTake: '',
    initials: '',
    declineValidation: {
        blockFutureMatchesValid: true,
        deactivatePairValid: true,
        lateReasonValid: true,
        rootCausePrimaryValid: true,
        rootCauseSecondaryValid: true,
        rejectionReasonTextValid: true,
        measuresToTakeValid: true,
        initialsValid: true
    },
    dirty: false
}

class DeclineXMDecision extends React.Component<IProps, IState> {
    readonly state: IState = initialState;

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show) {
            this.setState({ ...initialState });
        }
    }

    handleLateReasonChange = (e: React.FormEvent<FormControl & HTMLTextAreaElement>) => {
        this.setState({
            lateReason: e.currentTarget.value
        });
    }

    handleBlockFutureMatchesChange = (blockFutureMatches: boolean) => {
        this.setState({
            blockFutureMatches
        });
    }

    handleDeactivatePairChange = (deactivatePair: boolean) => {
        this.setState({
            deactivatePair
        });
    }

    handleRootCausePrimaryChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let rootCausePrimary = parseInt(e.currentTarget.value)

        this.setState({
            rootCausePrimary,
            declineValidation: { ...this.state.declineValidation, rootCausePrimaryValid: rootCausePrimary > -1 }
        });
    }

    handleRootCauseSecondaryChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let rootCauseSecondary = parseInt(e.currentTarget.value)

        this.setState({
            rootCauseSecondary,
            declineValidation: { ...this.state.declineValidation, rootCauseSecondaryValid: rootCauseSecondary > -1 }
        });
    }

    handleRejectReasonTextChange = (e: React.FormEvent<FormControl & HTMLTextAreaElement>) => {
        const value = e.currentTarget.value;

        this.setState({
            rejectionReasonText: value,
            declineValidation: { ...this.state.declineValidation, rejectionReasonTextValid: value != '' || value != undefined }
        });
    }

    handleMeasuresToTakeChange = (e: React.FormEvent<FormControl & HTMLTextAreaElement>) => {
        const value = e.currentTarget.value;

        this.setState({
            measuresToTake: value,
            declineValidation: { ...this.state.declineValidation, measuresToTakeValid: value != '' || value != undefined }
        });
    }

    handleInitialsChange = (e: React.FormEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;
        const initialsPopulated = value != '' || value != undefined;

        this.setState({
            initials: value,
            declineValidation: { ...this.state.declineValidation, initialsValid: initialsPopulated }
        });
    }

    handleSubmit = () => {
        let declineValidation = this.validateDecline();

        this.setState({
            declineValidation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let { blockFutureMatches, deactivatePair, lateReason, rootCausePrimary, rootCauseSecondary, rejectionReasonText, measuresToTake, initials } = this.state;
                this.props.onSubmitDecline(blockFutureMatches, deactivatePair, lateReason, rootCausePrimary, rootCauseSecondary, rejectionReasonText, measuresToTake, initials);
            }
        });
    }




    validateDecline = () => {
        let { blockFutureMatches, deactivatePair, lateReason, rootCausePrimary, rootCauseSecondary, rejectionReasonText, measuresToTake, initials, declineValidation } = this.state;

        let selectedRootCausePrimary = this.props.crossMatchRejectionReasonList.find(x => x.id == rootCausePrimary);
        let secondaryReasons = selectedRootCausePrimary != null ? selectedRootCausePrimary.secondaryReasons : [];

        declineValidation.blockFutureMatchesValid = blockFutureMatches != null;
        declineValidation.deactivatePairValid = deactivatePair != null;
        declineValidation.lateReasonValid = this.props.isPastDeadline ? lateReason != '' : true;
        declineValidation.rootCausePrimaryValid = rootCausePrimary >= 0;
        declineValidation.rootCauseSecondaryValid = secondaryReasons.length > 0 ? rootCauseSecondary >= 0 : true;
        declineValidation.rejectionReasonTextValid = rejectionReasonText != '';
        declineValidation.measuresToTakeValid = measuresToTake != '';
        declineValidation.initialsValid = initials != '';

        return declineValidation;
    }

    isValid = () => {
            let { declineValidation } = this.state;

            let { blockFutureMatchesValid: blockFutureMatches, deactivatePairValid: deactivatePair, lateReasonValid: declineLateReason, rootCausePrimaryValid: rootCausePrimary, rootCauseSecondaryValid: rootCauseSecondary, rejectionReasonTextValid: rejectionReasonText, measuresToTakeValid: measuresToTake, initialsValid: declineInitials } = declineValidation;

            return blockFutureMatches && deactivatePair && declineLateReason && rootCausePrimary && rootCauseSecondary && rejectionReasonText && measuresToTake && declineInitials;
    }

    render = () => {
        const isValid = this.isValid();
        const rootCauseList = _.sortBy(this.props.crossMatchRejectionReasonList, [item => item.displayOrder]);
        const rootCauseSecondaryList = this.state.rootCausePrimary >= 0 ? this.props.crossMatchRejectionReasonList.find(x => x.id == this.state.rootCausePrimary).secondaryReasons : [];

        return (
            <Modal bsSize='lg' show={this.props.show} backdrop='static' onHide={this.props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Donor Declined or XM Unacceptable</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.dirty && !isValid && (
                        <Alert bsStyle='danger'>
                            The items in red are required and must be completed prior to submitting your decision.
                        </Alert>
                    )}

                    <div style={{ position: 'relative', padding: 8 }}>
                        <>
                                <div className='row xm_rejected'>
                                    <FormGroup validationState={this.state.dirty && !this.state.declineValidation.blockFutureMatchesValid ? 'error' : null}>
                                        <Col lg={6} componentClass={ControlLabel}>
                                            Block All Future Matches between Recipent and Donor?
                                        </Col>
                                        <Col lg={6}>
                                            <label style={{ marginRight: 15 }}>
                                                <input
                                                    name='blockDonor'
                                                    type='radio'
                                                    style={{ marginRight: 5 }}
                                                    checked={this.state.blockFutureMatches != null && this.state.blockFutureMatches}
                                                    onClick={() => this.handleBlockFutureMatchesChange(true)} /> Block
                                            </label>
                                            <label>
                                                <input
                                                    name='blockDonor'
                                                    type='radio'
                                                    style={{ marginRight: 5 }}
                                                    checked={this.state.blockFutureMatches != null && !this.state.blockFutureMatches}
                                                    onClick={() => this.handleBlockFutureMatchesChange(false)} /> Don't Block
                                            </label>
                                        </Col>
                                    </FormGroup>
                                </div>

                                <div className='row xm_rejected'>
                                    <FormGroup validationState={this.state.dirty && !this.state.declineValidation.deactivatePairValid ? 'error' : null}>
                                        <Col lg={6} componentClass={ControlLabel}>
                                            Do you wish to deactivate your pair?
                                        </Col>
                                        <Col lg={6}>
                                            <label style={{ marginRight: 15 }}>
                                                <input
                                                    name='deactivatePair'
                                                    type='radio'
                                                    style={{ marginRight: 5 }}
                                                    checked={this.state.deactivatePair != null && this.state.deactivatePair}
                                                    onClick={() => this.handleDeactivatePairChange(true)} /> Yes
                                            </label>
                                            <label>
                                                <input
                                                    name='deactivatePair'
                                                    type='radio'
                                                    style={{ marginRight: 5 }}
                                                    checked={this.state.deactivatePair != null && !this.state.deactivatePair}
                                                    onClick={() => this.handleDeactivatePairChange(false)} /> No
                                            </label>
                                        </Col>
                                    </FormGroup>
                                </div>

                                {this.props.isPastDeadline && (
                                    <div className='row xm_rejected'>
                                        <FormGroup validationState={this.state.dirty && this.state.declineValidation.lateReasonValid == false ? 'error' : null}>
                                            <Col lg={6} componentClass={ControlLabel}>
                                                Please state the reason for being late:
                                            </Col>
                                            <Col lg={6}>
                                                <FormControl
                                                    componentClass='textarea'
                                                    cols={30}
                                                    rows={10}
                                                    style={{ height: 65 }}
                                                    value={this.state.lateReason}
                                                    onChange={this.handleLateReasonChange}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                )}

                                <div className='row xm_rejected'>
                                    <FormGroup validationState={this.state.dirty && !this.state.declineValidation.rootCausePrimaryValid ? 'error' : null}>
                                        <Col lg={6} componentClass={ControlLabel}>
                                            Primary Root Cause?
                                        </Col>
                                        <Col lg={6}>
                                            <FormControl
                                                componentClass='select'
                                                value={this.state.rootCausePrimary}
                                                onChange={this.handleRootCausePrimaryChange}
                                            >
                                                <option value={-1}>- please select -</option>
                                                {rootCauseList.map((item, index) =>
                                                    <option key={`prc-${index}`} value={item.id}>{item.description}</option>
                                                )}
                                            </FormControl>
                                        </Col>
                                    </FormGroup>
                                </div>

                                {rootCauseSecondaryList.length > 0 && (
                                    <div className='row wrapper'>
                                        <FormGroup validationState={this.state.dirty && !this.state.declineValidation.rootCauseSecondaryValid ? 'error' : null}>
                                            <Col lg={6} componentClass={ControlLabel}>
                                                Secondary Root Cause?
                                        </Col>
                                            <Col lg={6}>
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.state.rootCauseSecondary}
                                                    onChange={this.handleRootCauseSecondaryChange}
                                                >
                                                    <option value={-1}>- please select -</option>
                                                    {rootCauseSecondaryList.map((item, index) =>
                                                        <option key={`src-${index}`} value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </Col>
                                        </FormGroup>
                                    </div>
                                )}

                                <div className='row xm_rejected'>
                                    <FormGroup validationState={this.state.dirty && !this.state.declineValidation.rejectionReasonTextValid ? 'error' : null}>
                                        <Col lg={6} componentClass={ControlLabel}>
                                            What Happened?
                                            </Col>
                                        <Col lg={6}>
                                            <FormControl
                                                componentClass='textarea'
                                                cols={30}
                                                rows={10}
                                                style={{ height: 65 }}
                                                value={this.state.rejectionReasonText}
                                                onChange={this.handleRejectReasonTextChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </div>

                                <div className='row xm_rejected'>
                                    <FormGroup validationState={this.state.dirty && this.state.declineValidation.measuresToTakeValid == false ? 'error' : null}>
                                        <Col lg={6} componentClass={ControlLabel}>
                                            Corrective Action:
                                        </Col>
                                        <Col lg={6}>
                                            <FormControl
                                                componentClass='textarea'
                                                cols={30}
                                                rows={10}
                                                style={{ height: 65 }}
                                                value={this.state.measuresToTake}
                                                onChange={this.handleMeasuresToTakeChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </div>
                        </>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: 0, marginRight: 20 }} validationState={this.state.dirty && !this.state.declineValidation.initialsValid ? 'error' : null}>
                            <ControlLabel style={{ marginRight: 10, marginBottom: 0 }}>Your Initials <sup className='req'>*</sup></ControlLabel>
                            <input
                                className='form-control'
                                style={{ width: 50, lineHeight: '20px !important', padding: '4px 6px !important', marginRight: 10 }}
                                type='text'
                                maxLength={2}
                                value={this.state.initials}
                                onChange={this.handleInitialsChange}
                            />
                        </FormGroup>

                        <button className='btn btn-primary btn-lg' type='button' onClick={this.handleSubmit} disabled={!isValid}>Decline</button>
                        <button className='btn btn-lg btn-link' type='button' onClick={this.props.onCancel}>Cancel</button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DeclineXMDecision;